import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getCompanyName } from 'modules/playbook/selectors'
import { getDemoRequestProductName } from 'modules/playbook/selectors'
import { setProductName } from 'modules/playbook/actions'
import ProductStep from 'layouts/OnboardingPlaybookDemoRequestStep/ProductStep'

const mapStateToProps = (state) => {
  return {
    companyName: getCompanyName(state),
    productName: getDemoRequestProductName(state)
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setProductName,
  }, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(ProductStep)


// WEBPACK FOOTER //
// ./src/containers/OnboardingPlaybook/DemoRequestSteps/ProductName/index.js